export const stripHTML = (string: string) => {
  return string.replace(/(<([^>]+)>)/gi, '')
}
